module.exports = __webpack_public_path__ + "img/propvest-logo-dark.745fd99f.svg";